import { SearchInput } from "@/components/molecules/SearchInput";
import { CrmSystemCheckboxSelectSanitized } from "@/features/crm/components/organisms/CrmSystemCheckboxSelectSanitized";
import { SearchAndFilterByCrmSystemProps } from ".";



export function SearchAndFilterByCrmSystem({
    selectedCrmSystems,
    handleCheckboxChange,
    searchTerm,
    setSearchTerm,
    placeholder = "Search...",
    recordsByCrm,
}: SearchAndFilterByCrmSystemProps) {
    return (
        <div className="flex items-start justify-between gap-2">
            <div className="">
                <CrmSystemCheckboxSelectSanitized
                    checkedSystemsIds={selectedCrmSystems}
                    handleCheckboxChange={handleCheckboxChange}
                    recordsByCrm={recordsByCrm}
                />
            </div>
            <SearchInput
                value={searchTerm}
                setValue={setSearchTerm}
                placeholder={placeholder}
                wrapperProps={{ className: 'max-w-sm' }}
            />
        </div>
    );
}